import React from "react";
import {IEvent} from "../../../../models/Event";

export const Category: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="resaluts-container">
            <div className="categories">
                <h2 className="panel-title">קטגוריות</h2>
                {event.heats.map((heat,index) =>
                    !heat.amami && <div key={index} className="category-group">
                        <h3 className="panel-subtitle">מקצה {heat.description}</h3>
                        <ul className="chip-list">
                            {heat.sections?.map((section,index) =>
                                <li className="chip" key={index}>
                                    {section.description}
                                </li>)}
                        </ul>
                    </div>
                )}
            </div>
        </div >
    )
}
